module.exports = __webpack_public_path__ + "static/media/cozy-home_bg.447c550d.jpg";